import { render, staticRenderFns } from "./iconFaceRatings.vue?vue&type=template&id=7dd117b2&scoped=true"
import script from "./iconFaceRatings.vue?vue&type=script&lang=js"
export * from "./iconFaceRatings.vue?vue&type=script&lang=js"
import style0 from "./iconFaceRatings.vue?vue&type=style&index=0&id=7dd117b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd117b2",
  null
  
)

export default component.exports